import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adpkd-submissions',
  templateUrl: './submissions.component.html',
  styleUrls: ['./submissions.component.scss']
})
export class SubmissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
